// src/pages/SignupAcademy.js
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../css/SignupAcademy.css";
import axios from "axios";

const games = [
  { id: 1, slug: "cs2", title: "Counter-Strike 2" },
  { id: 2, slug: "valorant", title: "Valorant" },
  { id: 3, slug: "lol", title: "League of Legends" },
  { id: 4, slug: "fortnite", title: "Fortnite" },
  { id: 5, slug: "pubg", title: "Battlegrounds" },
  { id: 6, slug: "tft", title: "Team Fight Tactics" },
  { id: 7, slug: "fifa", title: "FIFA 25" },
  { id: 8, slug: "robloxminecraft", title: "Roblox / Minecraft" },
];

const days = [
  { id: 1, name: "Mandag" },
  { id: 2, name: "Tirsdag" },
  { id: 3, name: "Onsdag" },
  { id: 4, name: "Torsdag" },
  { id: 5, name: "Fredag" },
  { id: 6, name: "Lørdag" },
  { id: 7, name: "Søndag" },
];

const ProfileAcademy = () => {
  const location = useLocation();

  const [signupSuccess, setSignupSuccess] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [personalId, setPersonalId] = useState("");

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    birthDate: "",
    address: "",
    postal_code: "",
    city: "",
    country: "",
    parent_name: "",
    parent_email: "",
    parent_phone: "",
    ingame_name: "",
    game_id: "",
    game_name: "",
    training_time: "",
    day_id: "",
    day_name: "",
    level: ""
  });

  // =========================
  // INIT LOAD (SAFE + CLEAN)
  // =========================
useEffect(() => {
  const saved = JSON.parse(localStorage.getItem("academy_selection") || "{}");

  const merged = {
    ...saved,
    ...(location.state || {})
  };

  const gameId = Number(merged.game_id);
  const dayId = Number(merged.day_id);

  const game = games.find(g => g.id === gameId);
  const day = days.find(d => d.id === dayId);

  setForm(prev => ({
    ...prev,
    ...merged,
    game_id: gameId || "",
    day_id: dayId || "",
    game_name: game?.title || merged.game_name || "",
    day_name: day?.name || ""
  }));
}, [location.state]);

  // =========================
  // MAP GAME + DAY (FIXED)
  // =========================
  useEffect(() => {
    const game = games.find(g => g.id === Number(form.game_id));
    const day = days.find(d => d.id === Number(form.day_id));

    setForm(prev => ({
      ...prev,
      game_name: game?.title || "",
      day_name: day?.name || ""
    }));
  }, [form.game_id, form.day_id]);

  // =========================
  // SAVE TO LOCALSTORAGE
  // =========================
  useEffect(() => {
    const selectionOnly = {
      game_id: form.game_id,
      game_name: form.game_name,
      training_time: form.training_time,
      day_id: form.day_id,
      day_name: form.day_name,
      level: form.level
    };

    localStorage.setItem("academy_selection", JSON.stringify(selectionOnly));
  }, [
    form.game_id,
    form.game_name,
    form.training_time,
    form.day_id,
    form.day_name,
    form.level
  ]);

  // =========================
  // LOGIN CHECK
  // =========================
  useEffect(() => {
    axios
      .get("https://linxlegacyacademy.dk/auth/user", {
        withCredentials: true
      })
      .then(res => setIsAuthenticated(res.data.status === "logged_in"))
      .catch(() => setIsAuthenticated(false))
      .finally(() => setLoading(false));
  }, []);

  // =========================
  // INPUT CHANGE
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  // =========================
  // DISCORD REDIRECT
  // =========================
  useEffect(() => {
    if (!signupSuccess) return;

    setMessage("Tilmelding gennemført 🎉 Du bliver sendt til Discord...");

    const timer = setTimeout(() => {
      window.location.href = "https://discord.com/invite/cWUtWdThXu";
    }, 3000);

    return () => clearTimeout(timer);
  }, [signupSuccess]);

  // =========================
  // SUBMIT
  // =========================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setPersonalId("");

    try {
      const res = await axios.post(
        "https://linxlegacyacademy.dk/api/academy/signup",
        { ...form },
        { withCredentials: true }
      );

      if (res.data.status === "success") {
        setPersonalId(res.data.personal_id);
        setMessage(`Tilmelding gennemført! Dit ID: ${res.data.personal_id} 🎉`);

        setSignupSuccess(true); // ✅ VIS DISCORD LINK

        localStorage.removeItem("academy_selection");
      } else {
        setMessage(res.data.error || "Fejl");
      }
    } catch (err) {
      setMessage(err.response?.data?.error || "Fejl ved signup");
    }
  };

  if (loading) return <p>Loader...</p>;



  // =========================
  // alderen 
  // =========================
  const calculateAge = (birthDate) => {
  if (!birthDate) return 0;

  const today = new Date();
  const birth = new Date(birthDate);

  let age = today.getFullYear() - birth.getFullYear();

  const monthDiff = today.getMonth() - birth.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birth.getDate())
  ) {
    age--;
  }

  return age;
  };

  const under18 = calculateAge(form.birthDate) < 18;


  return (
    <div className="signup-page">

      <h1>Bliv bedre til dit spil 🎮</h1>

      <section className="benefits">
        <h2>Hvad får du som medlem?</h2>
        <ul>
          <li>🎮 Ugentlig træning med coach</li>
          <li>📈 Fokus på fællesskab og teamwork</li>
          <li>🏆 Turneringer og events</li>
          <li>💬 Aktivt community</li>
          <li>🔥 Seriøst og sjovt miljø</li>
        </ul>
      </section>

      <section className="instructions">
        <h2>Sådan fungerer det</h2>
        <ol>
          <li>Vælg spil og tid</li>
          <li>Kom til gratis prøvetræning</li>
          <li>Aktiver medlemskab</li>
        </ol>

        <p><strong>Pris:</strong> 2000 kr / halvår</p>
        <p>Første træning er gratis 🎯</p>
      </section>

      <section className="practical">
        <h2>Praktisk info</h2>
        <p><strong>Opstart:</strong> Efter aftale med træner</p>
        <p><strong>Sted:</strong> Discord eller lokalet</p>
        <p><strong>Varighed:</strong> 1-2 timer</p>
        <p><strong>Hold:</strong> 5-10 spillere</p>
      </section>

      <section className="game-info">
        <h3>Dit valgte hold</h3>

        <ul>
          <li><strong>Spil:</strong> {form.game_name || "Ikke valgt"}</li>
          <li><strong>Dag:</strong> {form.day_name || "Ikke valgt"}</li>
          <li><strong>Tid:</strong> {form.training_time || "Ikke valgt"}</li>
          <li><strong>Level:</strong> {form.level || "Ikke valgt"}</li>
        </ul>

        <a href="/Gametime" className="btn primary">
          Vælg holdtid
        </a>
      </section>

      {/* 🔥 LOGIN FLOW ONLY CHANGE */}
      <div className="connect-section">
        <button
          onClick={() =>
            window.location.href = "/auth/discord/login?type=academy"
          }
          className="btn primary"
        >
          {isAuthenticated ? "Discord forbundet" : "Login med Discord"}
        </button>
      </div>

      {!isAuthenticated && (
        <p>Du skal logge ind med Discord for at fortsætte</p>
      )}

      <form onSubmit={handleSubmit} className="signup-form">

        <h2>Udfyld dine oplysninger</h2>

        <label>Navn</label>
        <input name="name" value={form.name} onChange={handleChange} required />

        <label>Email</label>
        <input name="email" value={form.email} onChange={handleChange} required />

        <label>Telefon</label>
        <input name="phone" value={form.phone} onChange={handleChange} required />

        <label>Fødselsdato</label>
        <input
        name="birthDate"
        type="date"
        value={form.birthDate}
        onChange={handleChange}
        required
        />

        <label>Adresse</label>
        <input
        name="address"
        value={form.address}
        onChange={handleChange}
        required
        />

        <label>Postnummer</label>
        <input
          name="postal_code"
          value={form.postal_code}
          onChange={handleChange}
          required
        />

        <label>By</label>
        <input
        name="city"
        value={form.city}
        onChange={handleChange}
        required
        />

        <label>Land</label>
        <input
        name="country"
        value={form.country}
        onChange={handleChange}
        required
        />




        {under18 && (
          <>
            <label>Forældre navn</label>
            <input name="parent_name" value={form.parent_name} onChange={handleChange} />

            <label>Forældre email</label>
            <input name="parent_email" value={form.parent_email} onChange={handleChange} />

            <label>Forældre telefon</label>
            <input name="parent_phone" value={form.parent_phone} onChange={handleChange} />
          </>
        )}

        <label>Ingame navn</label>
        <input name="ingame_name" value={form.ingame_name} onChange={handleChange} />

        <button type="submit" disabled={!isAuthenticated}>
          Bliv medlem
        </button>

        {personalId && <p>Dit ID: {personalId}</p>}

      </form>

      {message && <p>{message}</p>}

      {/* ✅ DISCORD LINK EFTER SUCCESS */}
      {signupSuccess && (
        <a
          href="https://discord.com/invite/cWUtWdThXu"
          target="_blank"
          rel="noreferrer"
          className="btn primary"
        >
          Du bliver sendt til Discord - Klik her hvis du ikke bliver sendt automatisk
        </a>
      )}

    </div>
  );
};

export default ProfileAcademy;